import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-update-job-template',
  templateUrl: './update-job-template.component.html',
  styleUrls: ['./update-job-template.component.scss']
})
export class UpdateJobTemplateComponent implements OnInit {
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialogRef<UpdateJobTemplateComponent>,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
  }

  onCancel() {
    this.dialog.close(false);
  }

  onSubmit() {
    if (this.data.templateName !== this.data.originalTemplateName) {
     
      this.dialog.close(this.data);
      this.snackBar.open('Update value is changed', 'OK', {
        duration: 2000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center'
      });
    } else if (this.data.templateName==this.data.originalTemplateName || this.data.templateName.length==0) {
  
      this.snackBar.open(' No values are changed', 'OK', {
        duration: 2000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        panelClass: 'error-snackbar'
      });
    } else {
   
      this.snackBar.open('Error: ' + this.data.error, 'OK', {
        duration: 2000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        panelClass: 'error-snackbar'
      });
    }

  }

 

}
